import { ExperimentStore } from 'bernie-plugin-mobx';

import { getBucketValueByExperimentName } from 'utility';

const EXPERIMENT_NAME = 'content_hierarchy_feature_gate';

export const contentHierarchyFeatureGate = {
  shouldRender: (experiment: ExperimentStore): boolean => {
    return getBucketValueByExperimentName(experiment, EXPERIMENT_NAME) > 0;
  }
};
